import { render, staticRenderFns } from "./supplierPerformance.vue?vue&type=template&id=2d2a958d&scoped=true&"
import script from "./supplierPerformance.vue?vue&type=script&lang=js&"
export * from "./supplierPerformance.vue?vue&type=script&lang=js&"
import style0 from "./supplierPerformance.vue?vue&type=style&index=0&id=2d2a958d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2a958d",
  null
  
)

export default component.exports